import { render } from "./ExchangeName.vue?vue&type=template&id=6d6a2fec&scoped=true"
import script from "./ExchangeName.vue?vue&type=script&lang=js"
export * from "./ExchangeName.vue?vue&type=script&lang=js"

import "./ExchangeName.vue?vue&type=style&index=0&id=6d6a2fec&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-6d6a2fec"

export default script